import { render, staticRenderFns } from "./GeneralSlider.vue?vue&type=template&id=490488c9&scoped=true&"
import script from "./GeneralSlider.vue?vue&type=script&lang=js&"
export * from "./GeneralSlider.vue?vue&type=script&lang=js&"
import style0 from "./GeneralSlider.vue?vue&type=style&index=0&id=490488c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490488c9",
  null
  
)

export default component.exports